<template>
    <div class="all">
        <headC myId=1></headC>
        <headPic></headPic>
        <div class="products">
            <div class="product-title">MAIN PRODUCT</div>
        
            <!-- <div class="main-product-text">
                <span>
                    Kiusmod tempor sed incididunts labore sed dolor mag aliqua 
                    enimad mini veniam quis nostrud exercitation ullamco labores 
                    nisi ut aliquip. <br />
                    Lorem ipsum dolor tempor amety consecteur adipisicing elits do eiusmod 
                    tempor.
                </span>
            </div> -->
            <div :class="shrink ? 'product-list-shrink' : 'product-list'">
                <div v-for="item in productList" :key="item.name" :class="shrink ? 'product-item-shrink' : 'product-item'" 
                 @click="goDetail(item.id)"> 
                 
                    <div class="product-img-div">
                        <img :src=item.icon class="product-img" >
                    </div>
                    <span class="product-name" >{{ item.name }}</span>
                </div>
            </div>
            
            <div class="more-info">
                <a class="contact-a" @click="changePage(3)"><span>MORE INFO</span></a>
            </div>
        </div>

        <div class="contact-now"> 
            <span class="contact-span">
                Please leave your information to us, and we are ready to help you. Call Us at {{ mobile }}
                <a class="contact-a" @click="changePage(1)"><span class="button-contact">Contact Now</span></a>
            </span>
        </div>

        <div class="about-us">
            <div class="product-title">ABOUT US</div>
            <div class="about-text">
                Oclean Chemical Co., Ltd. is a comprehensive enterprise integrating production and trade. <br/>
                The main products are disinfection water treatment chemicals, such as Trichloroisocyanuric acid (TCCA), Sodium Dichloro Iso Cyanurate (SDIC) and calcium hypochlorite.    
            </div>
            <div class="read-more"><a class="contact-a" @click="changePage(2)"><span>READ MORE</span></a></div>
            <div class="about-us-image">
                <div v-for="item in usImages" :key="item.name" class="image-item">
                    <img :src=item.url class="product-img" >
                </div>
            </div>
        </div>
        
        <footC></footC>
    </div>

</template>
<script>
import headC from '../components/headC.vue'
import footC from '../components/footC.vue'
import headPic from '../components/headPic.vue'
export default ({
    name: 'homeV',
    components: {
        headC,
        footC,
        headPic,
    },
    data() {
        return {
            shrink: false,
            companyName: this.CONSTANT.companyName,
            curProduct: '',
            productList: this.PRODUCT.homeProductList,
            usImages: this.CONSTANT.usImages,
            mobile: this.CONSTANT.phone,
        };
    },
    
    methods:{
        handleResize() {
            // 页面宽度小于840px时，调整显示内容
            this.shrink = document.documentElement.clientWidth < 840 ? true : false;
        },
        changePage(num){
            if (num == 1) {
                this.$router.push('/contact')
            } else if (num == 2) {
                window.scrollTo(0, 0);
                this.$router.push('/about')
            }  else if (num == 3) {
                window.scrollTo(0, 0);
                this.$router.push({
                    name:'products',
                    params:{
                        category: -1,
                        subCategory: -1,
                    }
                })
            }
        },
        readMore(name) {
            this.curProduct = name;
        },
        goDetail (productId) {
            window.scrollTo(0, 0);
            this.$router.push('/products/detail/'+productId);
        },
    },
    mounted: function(){
        document.title= this.companyName + " | home";
        this.$axios.post("/access/1").then(function (){});   
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },

})
   
</script>
<style scoped>
.all{
    width: 100%;
    margin: 0 0 0 0;
}

.contact-now{
    background-color: #007ACC;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: white;
    word-break: break-word;
    white-space: pre-wrap;
    width: 90%;
    padding-top: 100px;
    padding-bottom: 100px;
    padding-left: 5%;
    padding-right: 5%;
}

.contact-a:hover{
    cursor: pointer;
}
.button-contact{
    font-size: 16px;
    border: white 1px solid;
    border-radius: 5px;
    padding: 15px 15px;
    background-color: #0570b7;
    margin-left: 20px;
    display: inline-block;
}
.about-us{
    width: 100%;
    background-color: #FCFCFC;
    padding-bottom: 20px;
}
.about-text{
    width: 90%;
    max-width: 1280px;
    margin: 30px auto;
    text-align: center;
}
.read-more{
    text-align: center;
    margin-top: 30px;
}
.read-more span{
    background-color: #007ACC;
    padding: 10PX 10PX;
    color: white;
    font-size: 16px;
}

/* 产品信息展示 */
.products {
    width: 100%;
    background-color: #FCFCFC;
    /* border: 1px solid; */
}
.product-title{
    font-size: 30px;
    text-align: center;
    padding-top: 25px;
}

.main-product-text{
    width: 90%;
    margin-left: 3%;
    text-align: center;
}
.main-product-text span{
    display: inline-block;
    width: 100%;
    word-break: break-word;
    white-space: pre-wrap;
    color:#666666;
    font-size: 18px;
    line-height: 40px;
    padding: 30px 20px;
}


.product-list{
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    
}

.product-list-shrink{
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    
}

.product-item{
    flex: 1 1 20%;
    position: relative;
    margin: 40px 2% 0 2%;
    width:20%;
    max-width: 20%;
    line-height: 30px;
    font-size: 20px;
    text-align: center;
    color: #333333;
    transition: all 0.5s ; 
    overflow: hidden;
}

.product-item-shrink{
    flex: 1 1 41%;
    position: relative;
    margin: 40px 3% 0 3%;
    width:41%;
    max-width: 41%;
    line-height: 30px;
    font-size: 20px;
    text-align: center;
    color: #333333;
    transition: all 0.5s ;
    overflow: hidden;
}

.product-item:hover{
    cursor: pointer;
    /* transform: translateY(-40px); */
    /* transition: all 0.5s ;  */
}
.product-item-shrink:hover{
    cursor: pointer;
    /* transform: translateY(-40px); */
    /* transition: all 0.5s ; */
}

.product-name:hover{
    color: #007ACC;
}

.product-img-div{
    width:100%;
    margin: 0 0;
    padding: 0 0;
    overflow: hidden;
    
}

.product-img{
    width: 100%;
    display: block;
    transition: transform 0.3s ease;
    
}
.product-img:hover{
    transform: scale(1.2);
}

.more-info{
    width: 100%;
    display: block;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
}
.more-info span{
    background-color: #007ACC;
    padding: 10PX 15PX;
    color: white;
    font-size: 14px;
}

.banner-product{
    width: 100%;
    margin-top: 10px;
    background-color: #007ACC;
    float: left;
}

.about-us-image{
    width: 90%;
    margin-left: 3%;
    margin-top: 40px;
}
.image-item{
    width: 28%;
    margin-left: 5%;
    float: left;
    margin-bottom: 40px;
    overflow: hidden;
}
.image-item img{
    cursor: pointer;
    transition: transform 0.3s ease;
}

.image-item img:hover{
    transform: scale(1.2);
}

</style>